import { render } from "./BoosterSubview.vue?vue&type=template&id=3855ba6e&scoped=true"
import script from "./BoosterSubview.vue?vue&type=script&lang=js"
export * from "./BoosterSubview.vue?vue&type=script&lang=js"

import "./BoosterSubview.vue?vue&type=style&index=0&id=3855ba6e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3855ba6e"]])

export default __exports__